<ion-content class="safe-area-top white">

    <app-modal-header></app-modal-header>

    <div class="d-flex flex-column gap-2">

        <div class="content-spacing px-lg">

            <div>
                <ng-lottie height="200px"
                           [options]="lottieOptions"/>
            </div>

            <div class="pt-sm">
                <div [innerHTML]="'Unisci alla rete' | translate" class="ts-h2-sans"></div>
                <div [innerHTML]="'Vivere la città' | translate" class="ts-body pt-xsm"></div>
            </div>

            <div class="d-flex flex-column gap-2 mt-md">
<!--

                &lt;!&ndash; Facebook &ndash;&gt;
                <ion-button expand="block" class="btn-facebook" (click)="loginWithFacebook()">
                    <ion-icon name="logo-facebook" slot="start"></ion-icon>
                    Accedi con Facebook
                </ion-button>
-->

                <!-- Google -->
                <ion-button expand="block" class="btn-google" (click)="loginWithGoogle()">
                    <img class="mr-sm" src="assets/icon/google.png" style="width: 24px;height: 24px;">
                    Accedi con Google
                </ion-button>

                <!-- Apple -->
                <ion-button *ngIf="commonService.isIos()"
                            expand="block" class="btn-apple app-shadow" (click)="loginWithApple()">
                    <ion-icon name="logo-apple" slot="start"></ion-icon>
                    Accedi con Apple
                </ion-button>

                <!-- Mail -->
                <ion-button expand="block"
                            class="outline"
                            (click)="loginWithMail()">
                    <ion-icon name="mail-outline" class="pr-sm"></ion-icon>
                    Accedi con email
                </ion-button>

            </div>

        </div>

    </div>

</ion-content>
